
import { Options, prop, Vue } from "vue-class-component";
import Search from "@/app/ui/components/search/index.vue";
import { ListGeoAddressApiRequest } from "@/data/payload/api/ManageAreaApiRequest";
import { PropType } from "vue";

class Props {
  modelValue = prop<ListGeoAddressApiRequest>({
    default: () => new ListGeoAddressApiRequest(),
    type: Object as PropType<ListGeoAddressApiRequest>,
    required: true
  });
}

@Options({
  components: {
    Search
  },
  emits: ["update:modelValue"]
})
export default class FilterModalArea extends Vue.with(Props) {
  onSearch(value = "") {
    if (!!value && value.length < 3) return;

    this.$emit(
      "update:modelValue",
      new ListGeoAddressApiRequest({ ...this.modelValue, q: value })
    );
  }
}
